import { ShoppingBasket } from 'lucide-react';
import { useQuote } from '@/context/QuoteContext';
import { QUOTE } from '@/constants/testIds';

export default function QuoteFab() {
  const { count, openDrawer, drawerOpen } = useQuote();

  if (drawerOpen) return null;

  return (
    <button
      type="button"
      onClick={openDrawer}
      data-testid={QUOTE.fab}
      aria-label={`Quote basket · ${count} items`}
      className="group fixed z-40 bottom-24 right-6 sm:bottom-28 sm:right-8 h-12 w-12 sm:h-14 sm:w-14 rounded-full bg-black/80 backdrop-blur border border-white/20 hover:border-white text-white shadow-[0_10px_40px_-10px_rgba(0,0,0,0.6)] flex items-center justify-center transition-all hover:scale-105"
    >
      <ShoppingBasket size={18} className="transition-transform group-hover:-rotate-6" />
      {count > 0 && (
        <span
          data-testid={QUOTE.fabBadge}
          className="absolute -top-1 -right-1 min-w-[20px] h-[20px] px-1.5 rounded-full bg-[var(--mw-primary)] text-white text-[10px] font-bold flex items-center justify-center border border-white/20"
        >
          {count}
        </span>
      )}
    </button>
  );
}
